var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AccordionWrapper',{attrs:{"active-counter":_vm.data.accordion.open ? 1 : 0}},[_c('AccordionItem',{attrs:{"opened-fn":_vm.data.accordion.fn,"show":_vm.data.accordion.open}},[_c('template',{slot:"accordion-trigger"},[_vm._t("title")],2),_c('template',{slot:"accordion-content"},[_vm._t("fields")],2)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }